/**
 * OKS-475 — platform support contact for PRE-brand-context surfaces.
 *
 * The role-gated login page (`/sign_in`) renders before any brand
 * context exists, so it cannot resolve a brand-specific support address
 * the way OKS-466's `OauthResultsController#support_url_for` does
 * (`brand.resolved_support_email`). It falls back to the platform
 * default — the same `support@oks.social` constant the backend uses as
 * its final fallback. Kept as a single `mailto:` constant so the
 * "Contact support" / "Contact the OKS team" links never drift.
 *
 * NOT a route → js-routes does not apply (a `mailto:` is not a Rails
 * path). If a brand-scoped or help-center support target is ever
 * needed here, thread it through as an Inertia prop instead of editing
 * this constant.
 */
export const SUPPORT_MAILTO = "mailto:support@oks.social"
